import * as React from 'react';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import {useDebounce} from 'shells/utils/hooks/use-debounce';

import {ContactFilter, ThreadBotStatus, ThreadType} from 'nutshell-graphql-types';

import {useGetLatestThreads, useGetChannelActiveStatuses} from '../graphql/hooks';
import {getThreadStatusFromSelectedTab} from '../helpers';
import {InboxPageContent} from '../shared-components';

type Props = ContextRouter & {
    assigneeIds: string[];
};

const THREAD_TYPE = ThreadType.CHAT;

export function ChatPage(props: Props) {
    const selectedPage = props.match.params.page;
    const status = getThreadStatusFromSelectedTab(selectedPage);
    const [search, setSearch] = React.useState('');
    const debouncedSearch = useDebounce(search, 250);

    const initialThreadId = React.useRef(props.match.params.id).current;

    const {
        latestThreads,
        totalCount,
        isLoading: isLoadingLatestThreads,
        fetchMoreRows: fetchMoreThreads,
        hasNextPage: hasMoreThreads,
    } = useGetLatestThreads({
        status,
        assignees: props.assigneeIds,
        threadType: THREAD_TYPE,
        findThreadId: initialThreadId || undefined,
        botStatus: NutClientConfig.hasEngagementBarV2FF ? ThreadBotStatus.BOT_DISABLED : undefined,
        contactFilter: ContactFilter.ALL,
        search: debouncedSearch || undefined,
    });

    const {channelActiveStatuses} = useGetChannelActiveStatuses({
        channelIds: latestThreads.map((thread) => thread.externalChannel.id),
    });

    if (channelActiveStatuses) {
        latestThreads.forEach((thread, index) => {
            thread.isActive = channelActiveStatuses[index] ?? false;
        });
    }

    return (
        <InboxPageContent
            {...props}
            selectedView={selectedPage}
            latestThreads={latestThreads}
            latestThreadsTotalCount={totalCount}
            isLoadingLatestThreads={isLoadingLatestThreads}
            fetchMoreThreads={fetchMoreThreads}
            hasMoreThreads={hasMoreThreads}
            assigneeIds={props.assigneeIds}
            threadType={THREAD_TYPE}
            search={search}
            onSearchChange={setSearch}
        />
    );
}
